import { FC, Fragment, useEffect, useMemo } from 'react';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { getIpInfo } from 'store/player/playerAsync';
import { setInitialState } from 'store/player/playerSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import PromoVideoDialog from 'dialogs/PromoVideo.dialog';
import QuizCountdown from './QuizCountdown';
import Prizes from 'components/Prizes';
import ButtonPlayNow from './ButtonPlayNow';
import PoweredBy from 'components/PoweredBy';
import HomeTitles from './HomeTitles';
import LanguageSelect from 'components/LanguageSelect';
import HomePageImage from './HomePageImage';

const StartPage:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz = useAppSelector(selectQuiz);

  const { open, toggle } = useToggle();

  const prizees = useMemo(() => {
    return quiz.prizes.filter(Boolean) || [];
  }, [quiz]);

  const spotPrizes = useMemo(() => {
    return quiz.spotPrizesEnabled && quiz.spotPrizes ? quiz.spotPrizes.filter(Boolean) : [];
  }, [quiz]);

  useEffect(() => {
    // Clear all player data
    dispatch(setInitialState());
    dispatch(getIpInfo());

    if ( quiz.promoVideo ) toggle();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div
        className="flex flex-col flex-1 p-4"
        style={{ background: quiz.landingPage?.backgroundImage ? `url('${quiz.landingPage.backgroundImage}') center / cover` : '' }}
      >
        <QuizCountdown />
        <HomePageImage />
        <HomeTitles />
        <ButtonPlayNow />
        <Prizes prizes={prizees} spotPrizes={spotPrizes} />
        <div className="flex-1" />
        <LanguageSelect />
        <PoweredBy />
      </div>
      {/* Promo video */}
      {open ? <PromoVideoDialog onClose={toggle} /> : null}
    </Fragment>
  )
}

export default StartPage;
